<script>
import TablePage from '../../../../../components/table_page';
import request from '../../../../../utils/request';
import Form from './form';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      requestUrl: '/sfa/sfacheckingroup/list',
      /** @desc 表单配置参数 */
      formConfig: {},
      /** @desc 请假参数配置 */
      formData: {
        year: '',
      },
      /** @desc 弹窗配置参数 */
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  async created() {
    await this.getConfigList('sfa_attendance_signgroup');
  },
  methods: {
    cellClick({ row, column }) {
      if (column.property === 'groupCode') {
        this.formConfig = {
          type: 'view',
          id: row.id,
          disabled: true,
        };
        this.modalConfig.title = '查看';
        this.openFull();
      }
    },
    modalClick({ val, row }) {
      let urls = '';
      let text = '';
      if (val.code === 'add') {
        this.formConfig.type = val.code;
        this.modalConfig.title = '新增';
        this.openFull();
      } else if (val.code === 'edit') {
        this.formConfig.type = val.code;
        this.formConfig.id = row.id;
        this.modalConfig.title = '编辑';
        this.openFull();
      } else if (val.code === 'enable') {
        urls = '/sfa/sfacheckingroup/enable';
        text = '启用';
        this.operationClick(urls, text);
      } else if (val.code === 'disable') {
        urls = '/sfa/sfacheckingroup/disable';
        text = '禁用';
        this.operationClick(urls, text);
      }
    },
    operationClick(urls, text) {
      let datas = [];
      if (this.selection.length > 0) {
        datas = this.selection;
        request.post(urls, datas).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: `${text}成功`,
            });
            this.selection = [];
            this.getList();
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: '请选择数据',
        });
      }
    },
  },
};
</script>
